import React from "react";
import { useNavigate } from "react-router-dom";
import jmcLogo from "../../assets/jmc-logo.png";

type Props = {
  title: string;
  active?:
    | "dashboard"
    | "createMerchant"
    | "manageMerchants"
    | "progress"
    | "approvedMerchants";
  children: React.ReactNode;
};

export default function StaffLayout({ title, active = "dashboard", children }: Props) {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("staff_email");
    localStorage.removeItem("staff_name");
    localStorage.removeItem("staff_google_token");
    localStorage.removeItem("staff_role");
    localStorage.removeItem("staff_department");
    navigate("/staff");
  };

  const MenuItem = ({
    label,
    isActive,
    onClick,
  }: {
    label: string;
    isActive: boolean;
    onClick: () => void;
  }) => (
    <button
      onClick={onClick}
      style={{
        width: "100%",
        textAlign: "left",
        padding: "11px 14px",
        borderRadius: 12,
        border: "1px solid rgba(255,255,255,0.22)",
        background: isActive ? "rgba(255,255,255,0.22)" : "rgba(255,255,255,0.06)",
        color: "#ffffff",
        fontSize: 14,
        fontWeight: 800,
        cursor: "pointer",
        transition: "all 0.15s ease",
      }}
      onMouseEnter={(e) => {
        if (!isActive) e.currentTarget.style.background = "rgba(255,255,255,0.16)";
      }}
      onMouseLeave={(e) => {
        if (!isActive) e.currentTarget.style.background = "rgba(255,255,255,0.06)";
      }}
    >
      {label}
    </button>
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        background: "linear-gradient(180deg, #2f5fa3 0%, #163a6f 60%, #0b1f3b 100%)",
      }}
    >
      {/* Sidebar */}
      <aside
        style={{
          width: 280,
          padding: 18,
          borderRight: "1px solid rgba(255,255,255,0.12)",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <div
          onClick={() => navigate("/staff/create-merchant")}
          role="button"
          tabIndex={0}
          style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer" }}
        >
          <img src={jmcLogo} alt="JMC" style={{ width: 42, height: 42 }} />
          <div>
            <div style={{ color: "#fff", fontWeight: 900, letterSpacing: 0.5 }}>JMC</div>
            <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 12 }}>スタッフ管理ポータル</div>
          </div>
        </div>

        <div style={{ marginTop: 18, color: "rgba(255,255,255,0.75)", fontSize: 12 }}>メニュー</div>

        {/* Menu items */}
        <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
          <MenuItem
            label="ダッシュボード"
            isActive={active === "dashboard"}
            onClick={() => navigate("/staff/dashboard")}
          />

          <MenuItem
            label="加盟店アカウント作成"
            isActive={active === "createMerchant"}
            onClick={() => navigate("/staff/create-merchant")}
          />

          <MenuItem
            label="加盟店アカウント管理"
            isActive={active === "manageMerchants"}
            onClick={() => navigate("/staff/merchants")}
          />

          

          {/* ✅ NEW: Approved merchants list */}
          <MenuItem
            label="承認済み一覧"
            isActive={active === "approvedMerchants"}
            onClick={() => navigate("/staff/approved")}
          />
        </div>

        {/* Push logout to bottom */}
        <div style={{ marginTop: "auto" }}>
          <div style={{ marginTop: 18, borderTop: "1px solid rgba(255,255,255,0.12)" }} />

          <button
            onClick={logout}
            style={{
              marginTop: 14,
              width: "100%",
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "rgba(255,255,255,0.08)",
              color: "#fff",
              cursor: "pointer",
              fontWeight: 700,
            }}
          >
            ログアウト
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, padding: 22, overflowX: "hidden" }}>
        <div style={{ color: "#fff", fontWeight: 900, fontSize: 22 }}>{title}</div>

        <div
          style={{
            marginTop: 14,
            background: "#ffffff",
            borderRadius: 16,
            padding: 18,
            boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
          }}
        >
          {children}
        </div>
      </main>
    </div>
  );
}
